import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function About({ onNext, serverType }) {
  return (
    <SoftBox>
      <SoftBox width="80%" textAlign="center" mx="auto" mb={4}>
        <SoftTypography variant="h4" fontWeight="bold">
          UDS {serverType === 'windows' ? 'Windows' : 'Linux'} Cloud Server
        </SoftTypography>
        <SoftTypography variant="body1" fontWeight="regular" color="text">
          {serverType === 'windows' 
            ? 'Windows Server in der Cloud - optimal für Unternehmensanwendungen, Remote Desktop Services und Windows-basierte Workloads.'
            : 'Linux Server in der Cloud - die flexible Lösung für Entwicklung, Hosting und containerisierte Anwendungen.'}
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Hauptmerkmale
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              {serverType === 'windows' ? (
                <>
                  • Windows Server 2019/2022/2025<br />
                  • Remote Desktop Services (RDS)<br />
                  • Active Directory Integration<br />
                  • Antivirus-Schutz verfügbar<br />
                  • Windows-Updates Management
                </>
              ) : (
                <>
                  • Ubuntu, Debian, CentOS, Rocky Linux<br />
                  • Docker & Kubernetes Support<br />
                  • Root-Zugriff via SSH<br />
                  • Automatische Security Updates<br />
                  • Optimiert für DevOps
                </>
              )}
            </SoftTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="h6" fontWeight="medium">
              Vorteile
            </SoftTypography>
            <SoftTypography variant="body2" color="text">
              • Flexible Ressourcen (RAM, CPU, Storage)<br />
              • Managed Firewall verfügbar<br />
              • Tägliche Backups optional<br />
              • 24/7 Technischer Support<br />
              • 99,9% Verfügbarkeitsgarantie
            </SoftTypography>
          </Grid>
        </Grid>
      </SoftBox>
      <SoftBox mt={4} textAlign="center">
        <Button variant="contained" color="primary" onClick={onNext}>
          Weiter zur Konfiguration
        </Button>
      </SoftBox>
    </SoftBox>
  );
}

About.propTypes = {
  onNext: PropTypes.func.isRequired,
  serverType: PropTypes.oneOf(['windows', 'linux']).isRequired
};

export default About;